import axios from '../components/shared/axios';

const staticServerBaseURL = process.env.REACT_APP_STATIC_SERVER_URL;

export const getCategories = async (params = {}) => {
  return await axios.get(`${staticServerBaseURL}/course-categories`);
};
export const formatCategories = (categories) => {
  return categories.map((category) => {
    return {
      ...category,
      subCategories: category.subCategories.map(
        (subCategory) => subCategory.name
      )
    };
  });
};
